<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      Thêm tem mới
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col cols="12">
              <div class="form-group m-0 has-label">
                <label class="form-control-label">
                  Loại Tem
                </label>
                <select v-model="temDetail.type" class="form-control">
                  <option value="BAG">Tem Bịch</option>
                  <option value="SACK">Tem Bao</option>
                  <option value="CORE">Tem Lõi</option>
                </select>
              </div>
              <base-input
                label="Số lượng"
                :mask="'number'"
                v-model="temDetail.quantity"
              ></base-input>
              <hr />
              <b-textarea
                v-model="temDetail.note"
                placeholder="Lý do tạo thêm tem"
                rows="3"
              ></b-textarea>
            </b-col>
          </b-row>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng (Esc)
        </button>
        <button type="button" @click="addTem()" class="btn btn-success">
          Thêm Tem
        </button>
      </ValidationObserver>
    </block>
    <event @doCancel="handleClose"></event>
  </modal>
</template>
<script>
import { temService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      tem: {},
      temDetail: {},
      ownInfo: {}
    };
  },
  methods: {
    addTem: function() {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        self.$refs.bmdal.block();
        self.isPending = true;
        temService
          .addTem(
            this.temDetail.quantity,
            this.temDetail.type,
            this.temDetail.note,
            this.tem
          )
          .then(res => {
            self.$emit("submit:success");
            self.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .finally(() => {
            self.visible = false;
            self.$refs.bmdal.unBlock();
          });
      });
    },
    setData(tem) {
      this.tem = Object.assign({}, tem);
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
